import { createAsyncAction } from 'typesafe-actions';
import { GroupLoginDto } from './login.dtos';

export const groupLoginActions = createAsyncAction(
  'LOGIN_GROUP_REQUEST',
  'LOGIN_GROUP_SUCCESS',
  'LOGIN_GROUP_ERROR',
)<GroupLoginDto, string, string>();